import { render, staticRenderFns } from "./PatternPanel.vue?vue&type=template&id=4b36c092&"
import script from "./PatternPanel.vue?vue&type=script&lang=js&"
export * from "./PatternPanel.vue?vue&type=script&lang=js&"
import style0 from "./PatternPanel.vue?vue&type=style&index=0&id=4b36c092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports